<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal__And__Centre_Alignment__And__Left_Indent__And__Right_Indent"><span><span style=" font-style: italic; font-size: 1.00em;">To every strong woman who has reached her deepest depths of pain and sorrow, then rose up to reinvent herself. May you continue to be the power in your own life that drives you to be your personal best.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?ff8bef0c